(() => {
  'use strict';
  class FloreoReview extends HTMLElement {
    connectedCallback() {
      this.views = [...this.querySelectorAll('[data-review-view]')];
      this.route = () => {
        const slug = location.hash.slice(1) || 'home';
        const selected = this.views.find(v => v.dataset.reviewView === slug) || this.views[0];
        this.views.forEach(v => v.hidden = v !== selected);
        this.querySelectorAll('.r2-header a').forEach(a => a.setAttribute('aria-current', a.hash === location.hash ? 'page' : 'false'));
        if (slug === 'about') this.querySelector('#about').scrollIntoView({block:'start'});
        else window.scrollTo({top:0,behavior:'instant'});
        const main = this.querySelector('main');
        if (location.hash) main.focus({preventScroll:true});
        document.title = selected.dataset.reviewView === 'home' ? 'Floreo — I Flourish' : `${selected.querySelector('h1')?.textContent || 'Floreo'} — Floreo`;
        this.querySelector('[data-review-status]').textContent = selected.querySelector('h1')?.textContent || 'Floreo';
      };
      addEventListener('hashchange', this.route); this.route();
    }
    disconnectedCallback() { removeEventListener('hashchange',this.route); }
  }
  class FloreoGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-review-zoom]');
      const image = this.main.querySelector('img'), dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const view = event.target.closest('[data-review-image]');
        if (view) {
          image.removeAttribute('srcset'); image.src = view.dataset.reviewImage;
          image.width = Number(view.dataset.imageWidth); image.height = Number(view.dataset.imageHeight);
          image.alt = view.dataset.imageAlt;
          this.main.style.setProperty('--gallery-background', view.dataset.imageSurface);
          dialog.style.setProperty('--gallery-background', view.dataset.imageSurface);
          dialog.style.color = ['#403f4c', '#5d5a59'].includes(view.dataset.imageSurface) ? '#fff' : '#111';
          this.querySelectorAll('[data-review-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===view)));
          this.querySelector('[data-image-caption]').textContent = view.dataset.imageKind;
        }
        if (event.target.closest('[data-review-zoom]')) {
          const zoom = dialog.querySelector('img'); zoom.src = image.currentSrc || image.src; zoom.alt = image.alt;
          dialog.showModal();
        }
        if (event.target.closest('[data-review-close]') || event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close',()=>this.main.focus({preventScroll:true}));
      dialog.addEventListener('keydown',event=>{
        if(event.key==='Tab'){event.preventDefault();dialog.querySelector('button').focus();}
      });
    }
  }
  if(!customElements.get('floreo-review'))customElements.define('floreo-review',FloreoReview);
  if(!customElements.get('floreo-gallery'))customElements.define('floreo-gallery',FloreoGallery);
})();
